import { styled } from "styled-components";

export const Wrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing[4]};
`;

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }
`;

export const TimelineTitle = styled.div<{ $withHover?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  padding: ${({ theme }) => theme.spacing[5]};
  padding-bottom: 0;
  font-size: ${({ theme }) => theme.fonts["2xl"].fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary.color};

  ${({ $withHover }) =>
    $withHover &&
    `
      span:hover  {
        text-decoration: underline;
        cursor: pointer;
      }
  `}
`;

export const TimelineShowInfo = styled.div`
  color: ${({ theme }) => theme.colors.text.primary.color};

  &:hover {
    color: ${({ theme }) => theme.colors.text.secondary.color};
    cursor: pointer;
  }
`;

export const TimelineTitleBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.primary.color};
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: ${({ theme }) => theme.spacing[1]};
  background-color: ${({ theme }) => theme.colors.button.primary.background};
  background: linear-gradient(
    43deg,
    rgba(18, 106, 243, 1) 0%,
    rgba(0, 74, 186, 1) 50%
  );
`;
